/**
 * ============================================================================
 * SERVICE: IndiaMART Integration Client Service
 * ============================================================================
 * Purpose:
 *   Handles API requests for IndiaMART CRM configuration, real-time sync,
 *   lead inspection, and manual/automated WhatsApp dispatches.
 * ============================================================================
 */

import api from "./api";

export const indiaMartService = {
  /**
   * Fetches tenant IndiaMART settings, active status, and unique webhook URL
   */
  getConfig: (params = {}) => api.get("/user/indiamart/config", { params }),

  /**
   * Saves updated IndiaMART CRM key, mobile, auto-reply text, sender phone, and toggles
   */
  saveConfig: (configData) => api.put("/user/indiamart/config", configData),

  /**
   * Generates a new secure token for the webhook callback URL
   */
  regenerateToken: () => api.post("/user/indiamart/regenerate-token"),

  /**
   * Tests connectivity to IndiaMART CRM Lead API using user's CRM Key
   */
  testConnection: (payload = {}) => api.post("/user/indiamart/test-connection", payload),

  /**
   * Manually triggers real-time pull from IndiaMART CRM Lead API and sends auto-replies
   */
  fetchLeadsNow: (payload = {}) => api.post("/user/indiamart/fetch-leads", payload),

  /**
   * Fetches paginated list of leads with search, status filters, and statistics
   */
  getLeads: (params = {}) => api.get("/user/indiamart/leads", { params }),

  /**
   * Dispatches or retries WhatsApp message for a specific lead
   */
  sendManualMessage: (leadId, payload = {}) =>
    api.post(`/user/indiamart/leads/${leadId}/send`, payload),
};

export default indiaMartService;
